// Ensure jQuery is loaded first
import $ from "jquery";
window.jQuery = window.$ = $;

